import React from 'react';
import Header from './Header';
import Sidebar from './Sidebar';
import BottomNav from './BottomNav';

const Layout = ({ children }) => {
  return (
    <div className="app">
      <Header />
      <main className="app__inner">
        <div className="layout">
          <Sidebar />
          <section className="content">
            {children}
          </section>
        </div>
      </main>
      <BottomNav />
    </div>
  );
};

export default Layout;